import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadsComponent } from './downloads.component';
import { DownloadsRoutingModule } from './downloads-routing.module';
import { AppCommonModule } from '@app/components/app.common.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TippyDirective } from '@ngneat/helipopper';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
  declarations: [
    DownloadsComponent
  ],
  imports: [
    CommonModule,
    DownloadsRoutingModule,
    AppCommonModule,
    FormsModule,
    ReactiveFormsModule,
    TippyDirective,
    BsDatepickerModule.forRoot(),
  ]
})
export class DownloadsModule { } 